import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ADMIN_URL } from '@prcins/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PackageComparisonService {
    constructor(http) {
        this.http = http;
    }
    getPackageComparisonData(state) {
        return this.http.get(`${ADMIN_URL.getPackageComparisonData}/${state}`);
    }
    savePackageComparisonData(state, payload) {
        return this.http.post(`${ADMIN_URL.savePackageComparisonData}/${state}`, payload);
    }
}
PackageComparisonService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PackageComparisonService_Factory() { return new PackageComparisonService(i0.ɵɵinject(i1.HttpClient)); }, token: PackageComparisonService, providedIn: "root" });
